module.exports = __webpack_public_path__ + "static/img/image3_new.f1a6aa9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image3_new.png
// module id = XgBM
// module chunks = 0